import type { ReactNode } from 'react';
import { cn } from '../lib/utils.ts';
export function PageHeading({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h1
      className={cn(
        'm-0 text-[clamp(2.4rem,7vw,4.5rem)] leading-[0.98] font-semibold tracking-[-0.045em]',
        className,
      )}
    >
      {children}
    </h1>
  );
}
